import { ApolloLink } from '@apollo/client'
import { GraphQLOptions } from '../types'

export const createServerTimingLink = (options: GraphQLOptions): ApolloLink =>
  new ApolloLink((operation, forward) =>
    forward(operation).map(response => {
      const { response: httpResponse } = operation.getContext()
      const serverTiming = httpResponse?.headers?.get('server-timing')
      if (serverTiming) {
        options.onServerTimingHeader?.(serverTiming)
      }
      return response
    }),
  )
